const DB_NAME = 'opticas';
const DB_VERSION = 1;
let DB;

export default {

	async getDb() {
		return new Promise((resolve, reject) => {

            
            if(DB) { 
                return resolve(DB); 
            }
            
			let request = window.indexedDB.open(DB_NAME, DB_VERSION);
			
			request.onerror = e => {
				console.log('Error opening db', e);
				reject('Error');
			};
	
			request.onsuccess = e => {
				DB = e.target.result;
				resolve(DB);
			};
			
			request.onupgradeneeded = e => {
				let db = e.target.result;
				db.createObjectStore("datos_pacientes", { autoIncrement: true, keyPath:'id' });
				db.createObjectStore("datos_proveedores_lente", { autoIncrement: true, keyPath:'id' });
				db.createObjectStore("datos_proveedores_montura", { autoIncrement: true, keyPath:'id' });
				db.createObjectStore("list_tipo", { autoIncrement: true, keyPath:'id' });
				db.createObjectStore("list_genero", { autoIncrement: true, keyPath:'id' });
				db.createObjectStore("list_eps", { autoIncrement: true, keyPath:'id' });
				db.createObjectStore("list_users", { autoIncrement: true, keyPath:'id' });
			};
		});
    },    
	async saveIdb(data) {
 		
		let db = await this.getDb();

		return new Promise(resolve => {

            let trans = db.transaction([data.list],'readwrite');
            
			trans.oncomplete = () => {
				resolve();
            };            
			let store = trans.objectStore(data.list);
			
			for (let i = 0; i < data.data.length; i++) {
				store.put(data.data[i]);				
			}            
		});	
	},
	async getIdb(list) {

		let db = await this.getDb();

		return new Promise(resolve => {

			let trans = db.transaction([list],'readonly');
			trans.oncomplete = () => {
				resolve(lists);
			};
			
			let store = trans.objectStore(list);
			let lists = [];
			
			store.openCursor().onsuccess = e => {
				let cursor = e.target.result;
				if (cursor) {
					lists.push(cursor.value)
					cursor.continue();
				}
			};

		});
	},

}